export const IconStrokeWidth = 2;
